/* ============================================================================
 * Knobs.co Cabinet Hardware Visualizer — editor engine
 * True-to-SKU overlay: composites the ACTUAL transparent product image onto a
 * customer photo. Deterministic compositing, never generative.
 *
 * Self-contained; configured via window.VISUALIZER_CONFIG so the same file runs
 * in this local harness and inside the Shopify theme.
 * ========================================================================== */
(function () {
  "use strict";

  var CFG = window.VISUALIZER_CONFIG || {};
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  // ---- DOM refs ----
  var stageWrap = $(".kv-stage-wrap");
  var stageEl = $("#kv-stage");
  var emptyEl = $("#kv-empty");
  var baseCtrls = $("#kv-base-ctrls");
  var ctxBar = $("#kv-ctx");
  var productsEl = $("#kv-products");
  var finishFiltersEl = $("#kv-finish-filters");
  var fileInput = $("#kv-file");
  var fileInputCam = $("#kv-file-cam");
  var toastEl = $("#kv-toast");
  var shareModal = $("#kv-share-modal");

  // ---- State ----
  var PRODUCTS = [];
  var productById = {};
  var productByHandle = {};
  var imageCache = {};            // src -> HTMLImageElement (loaded)
  var overlayCache = {};          // src -> processed overlay (canvas or img)
  var filters = { category: "", finish: "" };

  var stage, baseLayer, overlayLayer, bgRect, baseImageNode = null, transformer;
  var baseSrc = null;             // current photo source
  var selected = null;            // selected Konva hardware node

  var history = [];               // array of state snapshots
  var hIndex = -1;

  // ---------------------------------------------------------------- utilities
  function toast(msg, link) {
    toastEl.innerHTML = "";
    toastEl.appendChild(document.createTextNode(link ? msg + "  " : msg));
    if (link) {
      var a = document.createElement("a");
      a.href = link.href; a.textContent = link.text;
      a.style.color = "#fff"; a.style.textDecoration = "underline"; a.style.fontWeight = "700";
      toastEl.appendChild(a);
    }
    toastEl.hidden = false;
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toastEl.hidden = true; }, link ? 4500 : 2200);
  }

  function loadImage(src) {
    return new Promise(function (resolve, reject) {
      if (imageCache[src]) return resolve(imageCache[src]);
      var img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = function () { imageCache[src] = img; resolve(img); };
      img.onerror = function () { reject(new Error("Failed to load " + src)); };
      img.src = src;
    });
  }

  // Make a product image overlay-ready. Pre-made cut-outs (already transparent)
  // pass through untouched. Raw catalog shots on white get their background
  // knocked out in-browser (edge flood-fill) and cropped to content — so any
  // product works in the visualizer without a server-side cut-out.
  function prepareOverlay(img, src) {
    if (overlayCache[src]) return overlayCache[src];
    var w = img.naturalWidth || img.width, h = img.naturalHeight || img.height;
    var c = document.createElement("canvas"); c.width = w; c.height = h;
    var ctx = c.getContext("2d");
    ctx.drawImage(img, 0, 0, w, h);
    var data;
    try { data = ctx.getImageData(0, 0, w, h); }
    catch (e) { overlayCache[src] = img; return img; } // tainted -> use raw
    var px = data.data;
    // already has meaningful transparency? -> treat as a real cut-out, leave it
    var sampled = 0, trans = 0;
    for (var i = 3; i < px.length; i += 4 * 53) { sampled++; if (px[i] < 200) trans++; }
    if (sampled && trans / sampled > 0.04) { overlayCache[src] = img; return img; }
    // corners must look white-ish, else it's not a white-background shot -> leave it
    function nearWhite(o) { return px[o] > 232 && px[o + 1] > 232 && px[o + 2] > 232; }
    var corners = [0, (w - 1) * 4, (h - 1) * w * 4, ((h - 1) * w + (w - 1)) * 4];
    var whiteCorners = corners.filter(function (o) { return nearWhite(o); }).length;
    if (whiteCorners < 3) { overlayCache[src] = img; return img; }
    whiteFloodFill(px, w, h);
    ctx.putImageData(data, 0, 0);
    var out = autocropCanvas(c);
    overlayCache[src] = out;
    return out;
  }

  function whiteFloodFill(px, w, h) {
    var visited = new Uint8Array(w * h);
    var stack = [];
    function isWhite(idx) { var p = idx * 4; return px[p] > 232 && px[p + 1] > 232 && px[p + 2] > 232; }
    function seed(x, y) {
      if (x < 0 || y < 0 || x >= w || y >= h) return;
      var idx = y * w + x; if (visited[idx]) return; visited[idx] = 1;
      if (isWhite(idx)) stack.push(idx);
    }
    for (var x = 0; x < w; x++) { seed(x, 0); seed(x, h - 1); }
    for (var y = 0; y < h; y++) { seed(0, y); seed(w - 1, y); }
    while (stack.length) {
      var idx = stack.pop();
      px[idx * 4 + 3] = 0;
      var cx = idx % w, cy = (idx / w) | 0;
      seed(cx + 1, cy); seed(cx - 1, cy); seed(cx, cy + 1); seed(cx, cy - 1);
    }
  }

  function autocropCanvas(c) {
    var w = c.width, h = c.height;
    var d = c.getContext("2d").getImageData(0, 0, w, h).data;
    var minX = w, minY = h, maxX = 0, maxY = 0, found = false;
    for (var y = 0; y < h; y++) {
      for (var x = 0; x < w; x++) {
        if (d[(y * w + x) * 4 + 3] > 12) { found = true; if (x < minX) minX = x; if (x > maxX) maxX = x; if (y < minY) minY = y; if (y > maxY) maxY = y; }
      }
    }
    if (!found) return c;
    var pad = 6;
    minX = Math.max(0, minX - pad); minY = Math.max(0, minY - pad);
    maxX = Math.min(w - 1, maxX + pad); maxY = Math.min(h - 1, maxY + pad);
    var cw = maxX - minX + 1, ch = maxY - minY + 1;
    var out = document.createElement("canvas"); out.width = cw; out.height = ch;
    out.getContext("2d").drawImage(c, minX, minY, cw, ch, 0, 0, cw, ch);
    return out;
  }

  // Load any product by its handle (used when arriving from a product page).
  function loadProductByHandle(handle) {
    var base = CFG.pdpBase || "/products/";
    return fetch(base + encodeURIComponent(handle) + ".js")
      .then(function (r) { if (!r.ok) throw new Error("no product"); return r.json(); })
      .then(function (p) {
        var v = (p.variants && p.variants[0]) || {};
        var t = (p.type || "").toLowerCase();
        var cat = t.indexOf("knob") > -1 ? "Knob" : ((t.indexOf("pull") > -1 || t.indexOf("handle") > -1) ? "Pull" : (p.type || "Hardware"));
        var img = p.featured_image || (p.images && p.images[0]) || "";
        img = String(img).split("?")[0];
        if (img.indexOf("//") === 0) img = "https:" + img;
        if (img) img += "?width=900";
        var prod = {
          id: handle, handle: handle, title: p.title, brand: p.vendor, sku: "",
          category: cat, finish: "", finishLabel: p.type || p.vendor || "",
          price: v.price != null ? (v.price / 100).toFixed(2) : null,
          image: img, pdpUrl: base + handle, variantId: v.id, available: v.available
        };
        if (!productById[prod.id]) { PRODUCTS.unshift(prod); productById[prod.id] = prod; productByHandle[handle] = prod; renderProducts(); }
        return prod;
      });
  }

  // -------------------------------------------------------------- stage setup
  function initStage() {
    stage = new Konva.Stage({
      container: stageEl,
      width: stageWrap.clientWidth,
      height: stageWrap.clientHeight
    });
    baseLayer = new Konva.Layer();
    overlayLayer = new Konva.Layer();
    stage.add(baseLayer);
    stage.add(overlayLayer);

    // white backdrop so exported/empty areas are clean (not black/transparent)
    bgRect = new Konva.Rect({
      x: 0, y: 0, width: stage.width(), height: stage.height(),
      fill: "#ffffff", listening: true
    });
    baseLayer.add(bgRect);

    transformer = new Konva.Transformer({
      // Resize/rotate HANDLES rely on canvas-pixel hit detection, which privacy
      // browsers break — so disable them and use the toolbar buttons instead.
      // The transformer is kept purely as a selection outline.
      resizeEnabled: false,
      rotateEnabled: false,
      borderStroke: "#1b3a5b", borderStrokeWidth: 2, padding: 2
    });
    overlayLayer.add(transformer);

    // Select + drag by GEOMETRY, not Konva's pixel hit-test. Konva finds the
    // shape under the pointer by reading the hit canvas with getImageData —
    // which privacy browsers (Brave Shields fingerprint protection, Firefox
    // resistFingerprinting) corrupt, breaking select/drag/resize entirely.
    // Hit-testing by transform math avoids any canvas read, so it works
    // everywhere. Konva's drag *movement* uses pointer position (no canvas
    // read), so once we startDrag() it tracks fine.
    stage.on("mousedown touchstart", function (e) {
      if (e.type === "mousedown" && e.evt && e.evt.button !== 0) return;     // left button only
      if (e.target && e.target.getParent && e.target.getParent() === transformer) return; // let anchors resize/rotate
      var n = nodeAtPointer();
      if (n) { select(n); n.startDrag(); }
      else { deselect(); }
    });

    // Keep the stage glued to its container. The canvas has fixed pixel
    // dimensions, so without this it stays whatever size the container was at
    // init (0 in a collapsed/hidden container, wrong after a mobile rotation).
    if (window.ResizeObserver) {
      new ResizeObserver(function (entries) {
        var r = entries[0].contentRect;
        onContainerResize(Math.round(r.width), Math.round(r.height));
      }).observe(stageWrap);
    } else {
      window.addEventListener("resize", function () {
        onContainerResize(stageWrap.clientWidth, stageWrap.clientHeight);
      });
    }
  }

  // Resize the stage to (w,h) and scale existing content proportionally so the
  // layout survives container/orientation changes.
  function onContainerResize(w, h) {
    if (!stage || !w || !h) return;
    var ow = stage.width(), oh = stage.height();
    stage.width(w); stage.height(h);
    bgRect.width(w); bgRect.height(h);

    if (ow > 0 && oh > 0 && (ow !== w || oh !== h)) {
      var rx = w / ow, ry = h / oh, r = (rx + ry) / 2;
      var nodes = [];
      if (baseImageNode) nodes.push(baseImageNode);
      overlayLayer.getChildren(function (n) { return n.name() === "hardware"; })
        .forEach(function (n) { nodes.push(n); });
      nodes.forEach(function (n) {
        n.x(n.x() * rx); n.y(n.y() * ry);
        n.scaleX(n.scaleX() * r); n.scaleY(n.scaleY() * r); // sign (flip) preserved
      });
    } else if (ow === 0 && baseImageNode) {
      fitBaseCover(); // first real sizing after a 0-width init
    }
    baseLayer.batchDraw();
    overlayLayer.batchDraw();
  }

  // Scale/position the base photo to cover the stage, centered.
  function fitBaseCover() {
    if (!baseImageNode) return;
    var img = baseImageNode.image();
    var sw = stage.width(), sh = stage.height();
    var scale = Math.max(sw / img.width, sh / img.height);
    baseImageNode.scaleX(scale); baseImageNode.scaleY(scale);
    baseImageNode.rotation(0);
    baseImageNode.position({ x: sw / 2, y: sh / 2 });
  }

  // ------------------------------------------------------------- base (photo)
  function setBaseImage(src) {
    return loadImage(src).then(function (img) {
      baseSrc = src;
      if (baseImageNode) baseImageNode.destroy();

      baseImageNode = new Konva.Image({
        image: img,
        width: img.width, height: img.height,
        offsetX: img.width / 2, offsetY: img.height / 2,
        draggable: false,            // the backdrop stays put; only hardware moves
        name: "baseImage"
      });
      baseLayer.add(baseImageNode);
      fitBaseCover();
      baseLayer.batchDraw();

      emptyEl.style.display = "none";
      baseCtrls.hidden = false;
    });
  }

  function baseZoom(factor) {
    if (!baseImageNode) return;
    baseImageNode.scaleX(baseImageNode.scaleX() * factor);
    baseImageNode.scaleY(baseImageNode.scaleY() * factor);
    baseLayer.batchDraw();
    commit();
  }
  function baseRotate() {
    if (!baseImageNode) return;
    baseImageNode.rotation((baseImageNode.rotation() + 90) % 360);
    baseLayer.batchDraw();
    commit();
  }

  // ------------------------------------------------------- hardware instances
  function addProduct(product, opts) {
    opts = opts || {};
    return loadImage(product.image).then(function (raw) {
      var img = prepareOverlay(raw, product.image);   // knock out white bg if needed
      var iw = img.width, ih = img.height;
      var sw = stage.width();
      var targetW = sw * 0.18;                       // sensible default size
      var scale = targetW / iw;
      var minH = stage.height() * 0.10;              // keep thin pulls grabbable
      if (ih * scale < minH) scale = minH / ih;
      var node = new Konva.Image({
        image: img,
        width: iw, height: ih,
        offsetX: iw / 2, offsetY: ih / 2,
        x: opts.x != null ? opts.x : sw / 2,
        y: opts.y != null ? opts.y : stage.height() / 2,
        scaleX: opts.scaleX != null ? opts.scaleX : scale,
        scaleY: opts.scaleY != null ? opts.scaleY : scale,
        rotation: opts.rotation || 0,
        draggable: true,
        name: "hardware"
      });
      node.setAttr("productId", product.id);
      // Use Konva's default image hit (registers the piece's opaque pixels with
      // its hit colorKey reliably). A custom rect hitFunc + fillStrokeShape paints
      // nothing for a fill-less image, which left pieces unhittable -> undraggable.
      node.on("click tap", function (e) { e.cancelBubble = true; select(node); });
      node.on("dragstart", function () { node._kvStart = node.position(); select(node); });
      node.on("dragend", function () {
        var s = node._kvStart;
        if (!s || Math.abs(s.x - node.x()) > 0.5 || Math.abs(s.y - node.y()) > 0.5) commit();
      });
      node.on("transformend", commit);
      overlayLayer.add(node);
      transformer.moveToTop();
      select(node);
      overlayLayer.batchDraw();
      if (!opts.silent) commit();
      return node;
    });
  }

  // Topmost hardware piece under the pointer, by inverse-transform math (no
  // canvas pixel read -> immune to Brave/Firefox fingerprint protection).
  function nodeAtPointer() {
    var pos = stage.getPointerPosition();
    if (!pos) return null;
    var hw = overlayLayer.getChildren(function (x) { return x.name() === "hardware"; });
    for (var i = hw.length - 1; i >= 0; i--) {
      var n = hw[i];
      var p = n.getAbsoluteTransform().copy().invert().point(pos);
      if (p.x >= 0 && p.y >= 0 && p.x <= n.width() && p.y <= n.height()) return n;
    }
    return null;
  }

  function select(node) {
    selected = node;
    transformer.nodes([node]);
    transformer.moveToTop();
    overlayLayer.batchDraw();
    showCtxBar(node);
  }

  function deselect() {
    selected = null;
    transformer.nodes([]);
    overlayLayer.batchDraw();
    ctxBar.hidden = true;
  }

  function showCtxBar(node) {
    var p = productById[node.getAttr("productId")];
    ctxBar.hidden = false;
    $('[data-act="view"]', ctxBar).href = pdpUrlFor(p);
    var cartBtn = $('[data-act="cart"]', ctxBar);
    var soldOut = p && p.available === false;
    cartBtn.disabled = soldOut;
    cartBtn.textContent = soldOut ? "Sold out" : "Add to cart";
    cartBtn.style.opacity = soldOut ? "0.5" : "";
  }

  function pdpUrlFor(p) {
    if (p && p.pdpUrl) return p.pdpUrl;
    if (p && p.sku) return "https://knobs.co/search?q=" + encodeURIComponent(p.sku);
    return "https://knobs.co";
  }

  // contextual actions on the selected node
  function resizeSelected(factor) {
    if (!selected) return;
    selected.scaleX(selected.scaleX() * factor); // sign preserved (keeps flip)
    selected.scaleY(selected.scaleY() * factor);
    transformer.forceUpdate();
    overlayLayer.batchDraw();
    commit();
  }
  function rotateSelected(deg) {
    if (!selected) return;
    selected.rotation((selected.rotation() + deg) % 360);
    transformer.forceUpdate();
    overlayLayer.batchDraw();
    commit();
  }
  function flipSelected() { if (selected) { selected.scaleX(selected.scaleX() * -1); overlayLayer.batchDraw(); commit(); } }
  function forwardSelected() { if (selected) { selected.moveUp(); transformer.moveToTop(); overlayLayer.batchDraw(); commit(); } }
  function backSelected() { if (selected) { selected.moveDown(); overlayLayer.batchDraw(); commit(); } }
  function deleteSelected() {
    if (!selected) return;
    selected.destroy(); deselect(); overlayLayer.batchDraw(); commit();
  }

  function addToCart() {
    if (!selected) return;
    var p = productById[selected.getAttr("productId")];
    if (!CFG.cartAddUrl) { toast("Added (demo): " + p.title); return; }
    if (p.available === false || !p.variantId) {
      toast("Opening the product page to choose options");
      window.open(pdpUrlFor(p), "_blank");
      return;
    }
    var btn = $('[data-act="cart"]', ctxBar);
    var orig = btn.textContent;
    btn.disabled = true; btn.textContent = "Adding…";
    fetch(CFG.cartAddUrl, {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: p.variantId, quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.j && res.j.description) || "add failed");
        btn.textContent = "✓ Added";
        setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 1800);
        toast("Added to cart: " + p.title, { text: "View cart →", href: CFG.cartUrl || "/cart" });
        openThemeCart();
      })
      .catch(function (err) {
        btn.textContent = orig; btn.disabled = false;
        console.error("cart add failed", err);
        toast("Couldn't add — opening the product page");
        window.open(pdpUrlFor(p), "_blank");
      });
  }

  // Refresh + slide open the theme's own cart drawer so the add is visible
  // immediately (we add via AJAX, bypassing the theme's add button).
  function openThemeCart() {
    var cd = document.querySelector("cart-drawer");
    if (cd && typeof cd.refreshCartDrawer === "function") {
      var doOpen = function () { var d = document.querySelector("cart-drawer") || cd; try { d.open(); } catch (e) {} };
      try {
        var p = cd.refreshCartDrawer();             // async re-render; open AFTER it resolves
        if (p && typeof p.then === "function") p.then(doOpen, doOpen);
        else setTimeout(doOpen, 900);
      } catch (e) { doOpen(); }
      return;
    }
    if (typeof window.tkOpenCart === "function") { try { window.tkOpenCart(); return; } catch (e) {} }
    // last-resort: at least bump a visible count
    fetch((CFG.cartUrl || "/cart") + ".js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll(".header__cart-count-number, [data-cart-count], .cart-count").forEach(function (el) { el.textContent = cart.item_count; });
      }).catch(function () {});
  }

  // ----------------------------------------------------------------- history
  function snapshot() {
    var hardware = overlayLayer.getChildren(function (n) { return n.name() === "hardware"; })
      .map(function (n) {
        return {
          productId: n.getAttr("productId"),
          x: n.x(), y: n.y(), scaleX: n.scaleX(), scaleY: n.scaleY(), rotation: n.rotation()
        };
      });
    var base = baseImageNode ? {
      src: baseSrc, x: baseImageNode.x(), y: baseImageNode.y(),
      scaleX: baseImageNode.scaleX(), scaleY: baseImageNode.scaleY(), rotation: baseImageNode.rotation()
    } : null;
    return { base: base, hardware: hardware };
  }

  function commit() {
    history = history.slice(0, hIndex + 1);
    history.push(snapshot());
    hIndex = history.length - 1;
    updateUndoRedo();
  }

  function applyState(state) {
    // rebuild hardware from scratch (correct & simple)
    overlayLayer.getChildren(function (n) { return n.name() === "hardware"; })
      .slice().forEach(function (n) { n.destroy(); });
    deselect();

    var chain = Promise.resolve();
    if (state.base && baseImageNode) {
      baseImageNode.position({ x: state.base.x, y: state.base.y });
      baseImageNode.scaleX(state.base.scaleX); baseImageNode.scaleY(state.base.scaleY);
      baseImageNode.rotation(state.base.rotation);
      baseLayer.batchDraw();
    }
    state.hardware.forEach(function (h) {
      var p = productById[h.productId];
      if (!p) return;
      chain = chain.then(function () {
        return addProduct(p, {
          x: h.x, y: h.y, scaleX: h.scaleX, scaleY: h.scaleY, rotation: h.rotation, silent: true
        });
      });
    });
    chain.then(function () { deselect(); overlayLayer.batchDraw(); });
  }

  function undo() { if (hIndex > 0) { hIndex--; applyState(history[hIndex]); updateUndoRedo(); } }
  function redo() { if (hIndex < history.length - 1) { hIndex++; applyState(history[hIndex]); updateUndoRedo(); } }

  function updateUndoRedo() {
    $('[data-act="undo"]').disabled = hIndex <= 0;
    $('[data-act="redo"]').disabled = hIndex >= history.length - 1;
  }

  function reset() {
    if (!confirm("Start over? This clears your photo and all placed hardware.")) return;
    overlayLayer.getChildren(function (n) { return n.name() === "hardware"; })
      .slice().forEach(function (n) { n.destroy(); });
    if (baseImageNode) { baseImageNode.destroy(); baseImageNode = null; }
    baseSrc = null; deselect();
    baseLayer.batchDraw(); overlayLayer.batchDraw();
    emptyEl.style.display = "flex";
    baseCtrls.hidden = true;
    history = []; hIndex = -1; updateUndoRedo();
  }

  // ------------------------------------------------------------- save / share
  function openShare() {
    if (!baseImageNode) { toast("Add a photo first"); return; }
    deselect();
    // export only the photo's footprint when it is axis-aligned; else full stage
    var dataUrl = stage.toDataURL({ pixelRatio: 2, mimeType: "image/jpeg", quality: 0.92 });
    $("#kv-share-preview").src = dataUrl;
    shareModal._dataUrl = dataUrl;

    // share link carries the placed products so a phone opens ready
    var ids = overlayLayer.getChildren(function (n) { return n.name() === "hardware"; })
      .map(function (n) { return n.getAttr("productId"); });
    var primary = ids[ids.length - 1] || "";
    var shareUrl = CFG.pageUrl + (primary ? "?product=" + encodeURIComponent(primary) : "");
    shareModal._shareUrl = shareUrl;

    var qr = $("#kv-qr"); qr.innerHTML = "";
    if (window.QRCode) new QRCode(qr, { text: shareUrl, width: 140, height: 140 });

    shareModal.hidden = false;
  }

  function downloadImage() {
    var a = document.createElement("a");
    a.href = shareModal._dataUrl;
    a.download = "my-cabinets-knobsco.jpg";
    document.body.appendChild(a); a.click(); a.remove();
  }

  function copyLink() {
    var url = shareModal._shareUrl;
    if (navigator.clipboard) navigator.clipboard.writeText(url).then(function () { toast("Link copied"); });
    else { prompt("Copy this link:", url); }
  }

  // ------------------------------------------------------------- product UI
  function renderFinishFilters() {
    var finishes = [];
    PRODUCTS.forEach(function (p) { if (finishes.indexOf(p.finish) < 0) finishes.push(p.finish); });
    finishFiltersEl.innerHTML =
      '<button class="kv-fchip is-active" data-value="">All finishes</button>' +
      finishes.map(function (f) { return '<button class="kv-fchip" data-value="' + f + '">' + f + "</button>"; }).join("");
  }

  function renderProducts() {
    var list = PRODUCTS.filter(function (p) {
      return (!filters.category || p.category === filters.category) &&
             (!filters.finish || p.finish === filters.finish);
    });
    if (!list.length) { productsEl.innerHTML = '<p style="color:var(--kv-muted);padding:8px">No products match.</p>'; return; }
    productsEl.innerHTML = list.map(function (p) {
      return '<div class="kv-card" data-id="' + p.id + '">' +
        '<img class="kv-card__thumb" src="' + p.image + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' +
        '<div class="kv-card__title">' + escapeHtml(p.title) + '</div>' +
        (p.price ? '<div class="kv-card__price">$' + p.price + "</div>" : "") +
        '<div class="kv-card__finish">' + escapeHtml(p.finishLabel || p.finish) + "</div>" +
        "</div>";
    }).join("");
  }

  function escapeHtml(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  // ------------------------------------------------------------------ events
  function wireEvents() {
    document.addEventListener("click", function (e) {
      var act = e.target.closest("[data-act]");
      if (act) handleAction(act.getAttribute("data-act"), e);

      var card = e.target.closest(".kv-card");
      if (card) onPickProduct(card.getAttribute("data-id"));

      var fchip = e.target.closest(".kv-fchip");
      if (fchip) onFilterChip(fchip);
    });

    fileInput.addEventListener("change", onFile);
    fileInputCam.addEventListener("change", onFile);
  }

  function handleAction(act, e) {
    switch (act) {
      case "upload": pickPhoto(); break;
      case "sample": setBaseImage(CFG.sampleImage || "sample-kitchen.jpg").then(commit); break;
      case "undo": undo(); break;
      case "redo": redo(); break;
      case "reset": reset(); break;
      case "share": openShare(); break;
      case "base-zoom-in": baseZoom(1.1); break;
      case "base-zoom-out": baseZoom(0.9); break;
      case "base-rotate": baseRotate(); break;
      case "bigger": resizeSelected(1.15); break;
      case "smaller": resizeSelected(1 / 1.15); break;
      case "rot-l": rotateSelected(-15); break;
      case "rot-r": rotateSelected(15); break;
      case "flip": flipSelected(); break;
      case "forward": forwardSelected(); break;
      case "back": backSelected(); break;
      case "delete": deleteSelected(); break;
      case "cart": addToCart(); break;
      case "download": downloadImage(); break;
      case "copylink": copyLink(); break;
      case "close-share": shareModal.hidden = true; break;
    }
  }

  function onPickProduct(id) {
    var p = productById[id];
    if (!p) return;
    if (!baseImageNode) { toast("Add a photo first, then tap a product"); return; }
    addProduct(p);
  }

  function onFilterChip(chip) {
    var group = chip.closest(".kv-filter-group");
    var type = group.getAttribute("data-filter");
    $$(".kv-fchip", group).forEach(function (c) { c.classList.remove("is-active"); });
    chip.classList.add("is-active");
    filters[type] = chip.getAttribute("data-value");
    renderProducts();
  }

  function pickPhoto() {
    // prefer rear camera on mobile, file picker on desktop
    var isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    (isMobile ? fileInputCam : fileInput).click();
  }

  function onFile(e) {
    var file = e.target.files && e.target.files[0];
    if (!file) return;
    var reader = new FileReader();
    reader.onload = function () { setBaseImage(reader.result).then(commit); };
    reader.readAsDataURL(file);
    e.target.value = "";
  }

  // ------------------------------------------------------------------- helpers
  function debounce(fn, ms) {
    var t; return function () { clearTimeout(t); var a = arguments, c = this; t = setTimeout(function () { fn.apply(c, a); }, ms); };
  }

  function preselectFromUrl() {
    var key = new URLSearchParams(location.search).get("product");
    if (!key) return;
    var prod = productById[key] || productByHandle[key];
    if (prod) { highlightProduct(prod); loadImage(prod.image).catch(function () {}); return; }
    // not a curated bestseller -> load it live from its product page
    loadProductByHandle(key).then(highlightProduct).catch(function () { toast("Couldn't load that product"); });
  }

  function highlightProduct(prod) {
    filters = { category: "", finish: "" };
    renderProducts();
    var card = $('.kv-card[data-id="' + prod.id + '"]');
    if (card) { card.scrollIntoView({ inline: "center", block: "nearest" }); card.style.outline = "2px solid var(--kv-accent)"; }
    toast("Tap “" + prod.title + "” to place it");
  }

  // --------------------------------------------------------------------- boot
  function initProducts(data) {
    PRODUCTS = (data && data.products) || [];
    PRODUCTS.forEach(function (p) { productById[p.id] = p; if (p.handle) productByHandle[p.handle] = p; });
    renderFinishFilters();
    renderProducts();
    PRODUCTS.forEach(function (p) { loadImage(p.image).catch(function () {}); }); // warm cache
    preselectFromUrl();
  }

  function boot() {
    initStage();
    wireEvents();
    // In the Shopify theme the curated set is rendered inline by Liquid (with
    // asset_url image paths + real variant IDs). Locally we fetch products.json.
    var inline = document.getElementById("kv-products-data");
    if (inline) {
      try { initProducts(JSON.parse(inline.textContent)); return; }
      catch (e) { console.error("bad inline products", e); }
    }
    fetch(CFG.productsUrl)
      .then(function (r) { return r.json(); })
      .then(initProducts)
      .catch(function (err) { toast("Couldn't load products"); console.error(err); });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
